import AssetIcon from '@admin/components/asset_icon'
import Icon from '@admin/components/icon'
import PropTypes from 'prop-types'
import React from 'react'

class ImageAttachment extends React.Component {

  static propTypes = {
    file: PropTypes.object,
    onRemove: PropTypes.func
  }

  _handleRemove = this._handleRemove.bind(this)

  render() {
    const { file } = this.props
    return (
      <div className="maha-composer-file">
        <div className="maha-composer-file-detail">
          <div className="maha-composer-file-icon">
            <AssetIcon { ...this._getAssetIcon() } />
          </div>
          <div className="maha-composer-file-name">
            { this._getFileName() }
          </div>
          { !file.id ?
            <div><Icon icon="circle-o-notch fa-spin" /></div> :
            <Icon icon="times" onClick={ this._handleRemove } />
          }
        </div>
      </div>
    )
  }

  _getAssetIcon() {
    const { file } = this.props
    return {
      content_type: file.content_type || 'plain/text',
      source: 'device'
    }
  }

  _getFileName() {
    const { file } = this.props
    return file.file_name || file.file.fileName
  }

  _handleRemove() {
    this.props.onRemove()
  }

}

export default ImageAttachment
